import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
const testimonials = [{
  text: 'Insegno da 14 anni e questo è il primo strumento che mi fa davvero risparmiare tempo senza sacrificare la qualità. I miei studenti hanno migliorato i voti di un punto pieno in informatica.',
  highlight: '+1 punto in informatica',
  name: 'Marco D.',
  role: 'Istituto Tecnico',
  city: 'Bologna'
}, {
  text: 'Il soluzionario Python è oro puro. Non devo più fare il debugging la sera prima. La mia classe ora scrive codice con un entusiasmo mai visto.',
  highlight: 'Serate libere ritrovate',
  name: 'Lucia M.',
  role: 'Scuola Media',
  city: 'Napoli'
}, {
  text: 'Le slide LIM sugli algoritmi sono straordinarie. Recupero almeno 4 ore di preparazione a settimana — quasi mezza giornata libera.',
  highlight: '+4 ore libere a settimana',
  name: 'Paolo C.',
  role: 'Istituto Tecnico',
  city: 'Firenze'
}, {
  text: 'Pensavo fosse il solito PDF generico. Invece ho trovato un percorso completo. Ho usato i materiali BES con due alunni DSA e hanno passato la verifica.',
  highlight: 'Inclusione DSA e BES',
  name: 'Giulia R.',
  role: 'Scuola Media',
  city: 'Torino'
}, {
  text: 'Ho finalmente recuperato le mie serate. Le slide su Python hanno illuminato i miei ragazzi della quinta. Indispensabile per chi insegna alle superiori.',
  highlight: 'Programmazione più chiara',
  name: 'Alessandro P.',
  role: 'Liceo Scientifico',
  city: 'Roma'
}, {
  text: 'Cambio scuola ogni anno e dover preparare tutto da zero mi distruggeva. Con Programmazione Pronta arrivo il primo giorno con il programma già impostato.',
  highlight: "Pronto dall'inizio",
  name: 'Sara B.',
  role: 'Docente Precaria',
  city: 'Bari'
}];
export function Testimonials() {
  return <section className="py-10 sm:py-14 px-4" data-id="element-239">
      <div className="max-w-xl mx-auto" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-241">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-3" data-id="element-242">
            Cosa dicono i docenti che lo usano ogni giorno.
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-243">
            Oltre 500 docenti italiani hanno già scelto Programmazione Pronta.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-244">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-card border border-white/5 p-5 rounded-2xl" data-id="element-245">
              <div className="flex items-center gap-2 mb-3" data-id="element-246">
                <div className="flex text-brand-gold" data-id="element-247">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-3.5 h-3.5 fill-current" data-id="element-248" />)}
                </div>
                <span className="inline-flex items-center gap-1 text-[11px] font-bold text-green-400" data-id="element-249">
                  <BadgeCheckIcon className="w-3.5 h-3.5" data-id="element-250" /> Verificato
                </span>
              </div>
              <p className="text-gray-300 text-sm font-medium italic mb-3 leading-snug" data-id="element-251">
                "{t.text}"
              </p>
              <div className="border-t border-white/10 pt-3 flex flex-wrap justify-between items-center gap-2" data-id="element-252">
                <span className="text-xs font-bold text-brand-orange" data-id="element-253">
                  {t.highlight}
                </span>
                <span className="text-xs text-gray-400 font-medium" data-id="element-254">
                  — {t.name}, {t.role}, {t.city}
                </span>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center text-sm text-gray-400 mt-6 font-medium" data-id="element-255">
          +500 docenti hanno già scelto il Kit — 4.9/5 recensioni verificate
        </p>
      </div>
    </section>;
}